module.exports = __webpack_public_path__ + "static/media/devconnector.3f9f7b4a.png";